<section
	*ngIf="tabData?.config && tabData?.displayConfig?.visible"
	class="display-table"
	[ngClass]="{ bordered: bordered, padded: padded, 'padding-bottom-40': data?.config?.id.includes('.benchmark') }"
>
	<header
		*ngIf="tableData?.headersX?.length"
		class="row align-items-bottom"
		[ngClass]="{
			'margin-adjustment': !hideRows,
			'border-color-black': tableOptions?.shouldShowSeparatorLineBelowParent,
			'border-color-regular': !tableOptions?.shouldShowSeparatorLineBelowParent
		}"
	>
		<span *ngIf="tableOptions?.shouldShowExpandIconOnLeft" [ngClass]="expandIconColumnClass"></span>
		<span *ngIf="tableData.firstColumnTitle" class="col text-14-bold category-column" [ngClass]="categoryColumnClass" [class.hidden-sm]="tableData.headersX.length !== 1">
			<span>
				{{ tableData.firstColumnTitle.formattedValue }}
				<dcr-cell-content [cell]="tableData.firstColumnTitle"></dcr-cell-content>
			</span>
		</span>
		<ng-container *ngIf="!hideRows">
			<ng-container *ngFor="let header of tableData.headersX; index as i">
				<span *ngIf="header?.config?.visible" class="col text-14-bold text-align-right" [ngClass]="dataColumnClass" attr.data-cy="dl-display-table-header-{{ i }}">
					<span [forcedLineBreak]="headersXFormatter.formatter(header.formattedValue)" class="icon-caption"></span>
					<p class="text-10" *ngIf="data?.config?.id.includes('.benchmark')" dcrHTMLKey="OVER_UNDER_WEIGHT_LABEL">(Over/Under Weight)</p>
					<ng-container *ngIf="header?.attribute?.infoBubble">
						<icon
							type="info-circle"
							class="info-circle text-14 color-primary"
							*ngIf="header.config.infoBubble.key !== 'TOTAL_RISK_TOOLTIP'"
							[tooltip]="infoBubble"
							[analytic-data]="{ linkName: 'tooltip_' + header.config.infoBubble.key }"
						></icon>
						<icon
							type="info-circle"
							class="info-circle text-14 color-primary pointer"
							*ngIf="header.config.infoBubble.key === 'TOTAL_RISK_TOOLTIP'"
							(click)="toggleInfoDialog()"
						></icon>
					</ng-container>
					<dcr-cell-content [cell]="header"></dcr-cell-content>
					<ng-template #infoBubble> <section [innerHTML]="tooltipFormatter.formatter(header.attribute.infoBubble)"></section> </ng-template>
				</span>
			</ng-container>
		</ng-container>
	</header>

	<dl-simple-table
		*ngIf="!hasChildRows && !hideRows"
		[data]="tableData"
		[category-classes]="categoryColumnClass"
		[data-classes]="dataColumnClass"
		[striped]="striped"
		[colors]="colors"
	></dl-simple-table>
	<dl-simple-first-column-table
		*ngIf="!hasChildRows && hideRows"
		[data]="tableData"
		[category-classes]="categoryColumnClass"
		[data-classes]="dataColumnClass"
		[striped]="striped"
		[colors]="colors"
	></dl-simple-first-column-table>
	<dl-nested-table
		*ngIf="hasChildRows && !parentCollapsed && !hideRows"
		[data]="tableData"
		[category-classes]="categoryColumnClass"
		[data-classes]="dataColumnClass"
		[expand-icon-classes]="expandIconColumnClass"
		[icon-classes]="iconColumnClass"
		[striped]="striped"
		[colors]="colors"
		[tableOptions]="tableOptions"
	></dl-nested-table>

	<section *ngIf="totalData?.headersY?.length" class="row total-row text-14-bold">
		<span class="col text-align-left" [ngClass]="categoryColumnClass">{{ totalData.headersY[0].formattedValue }}</span>
		<ng-container *ngFor="let cell of totalData.cells[0]">
			<section *ngIf="cell.formattedValue; else notApplicable" class="col text-align-right" [ngClass]="dataColumnClass">{{ cell.formattedValue }}</section>
			<dcr-cell-content [cell]="cell"></dcr-cell-content>
		</ng-container>
	</section>
</section>

<bfa-modal width="750px" [enableBackdrop]="true" [enableClose]="true" [isVisible]="showRiskInfoBubbleModal" (isVisibleChange)="showRiskInfoBubbleModal = false">
	<section class="modal-message-container" [innerHTML]="riskInfoBubbleText"></section>
</bfa-modal>
